import { URL_CHAT_JUSIA } from '../core/constants'

export interface GenerateThreadUrlProps {
  threadId?: string
  question: string
  autoSend?: boolean
  origin: string
}

export function generateThreadUrl({
  threadId,
  question,
  autoSend = true,
  origin,
}: GenerateThreadUrlProps): string {
  const base = threadId ? `${URL_CHAT_JUSIA}/c/${threadId}/` : URL_CHAT_JUSIA
  const params = new URLSearchParams()
  params.append('origin', origin)
  params.append('q', question)
  if (autoSend) {
    params.append('send', '')
  }
  return `${base}?${params.toString()}`
}
